import classnames from 'classnames';
import { type FC, type ReactNode, useMemo } from 'react';
import { useClientProfile } from 'store';
import { Translation } from 'utils/translations';
import useIntl from 'utils/useIntl';
import styles from './UserInfo.module.scss';

interface UserInfoProps {
  children?: ReactNode;
  className?: string;
}

const UserInfo: FC<UserInfoProps> = ({ children, className }) => {
  const { formatMoney } = useIntl();
  const [clientProfile] = useClientProfile();
  const {
    data: {
      client: { firstName, lastName, id } = {},
      wallet: {
        balance = 0,
        detailedBalance: { BONUS: bonus } = {},
      } = {},
    } = {},
  } = clientProfile;
  const userBalance = useMemo(
    () => formatMoney(balance),
    [balance, formatMoney],
  );
  const userBonus = useMemo(() => formatMoney(bonus), [bonus, formatMoney]);
  const userName = useMemo(() => {
    const name = [firstName, lastName].filter(Boolean);
    return name.join(' ');
  }, [firstName, lastName]);

  if (!clientProfile.data) {
    return null;
  }

  return (
    <div className={classnames(styles.information, className)}>
      <div className={styles.column}>
        {userName && (
          <div title={userName} className={styles['text-bold']}>
            {userName}
          </div>
        )}
        <div className={styles.text}>
          <Translation message="id" />
          &nbsp;
          {id}
        </div>
      </div>
      {children}
      <div className={classnames(styles.column, styles['user-balance'])}>
        <div className={styles['user-balance-value']}>{userBalance}</div>
        <div className={classnames(styles.text, styles.green)}>
          <Translation message="bonus_balance" />
          &nbsp;
          {userBonus}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
